import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { RichTextField, TextField } from '@sitecore-jss/sitecore-jss-angular';

import { OfferOverviewChangeOfferComponent } from '../../order-overview-shared/offer-overview-change-offer/offer-overview-change-offer.component';
import { OrderOverviewBudgetBillCostComponent } from '../order-overview-budget-bill-cost/order-overview-budget-bill-cost.component';

@Component({
  selector: 'essent-order-overview-header',
  templateUrl: './order-overview-header.component.html',
  styleUrls: ['./order-overview-header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CSCaptureDirective,
    OfferOverviewChangeOfferComponent,
    OrderOverviewBudgetBillCostComponent,
  ],
})
export class OrderOverviewHeaderComponent {
  readonly offer = input<Offer>();
  readonly monthlyAmountLabel = input.required<TextField>();
  readonly budgetBillLabel = input.required<RichTextField>();
  readonly monthlyAmountTooltip = input('');
  readonly budgetBillTooltip = input('');
  readonly costsWithDiscountLabel = input('');
  readonly showEditButton = input(false);
  readonly fluidContainer = input(false);
  readonly showCostsInHeader = input(false);
  readonly enableNewOfferCardTitles = input(false);
}
